export class LaboratoryDTO {

    id?: number;
    name: string;
    document: string;
    serviceRateTarget: number;
    serviceRateTargetFormatted: string;
    lateOrdersRateTarget: number;
} 